function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

import { setInterval, clearInterval } from './timer';
import { removeItem } from './utils/arrayUtils';
import { addDuration, relativeNow, ONE_MINUTE } from './utils/timeUtils';
var END_OF_TIMES = Infinity;
export var CLEAR_OLD_VALUES_INTERVAL = ONE_MINUTE;
var cleanupHistoriesInterval = null;
var cleanupTasks = new Set();

function cleanupHistories() {
  cleanupTasks.forEach(function (task) {
    return task();
  });
}

export function createValueHistory(_ref) {
  var expireDelay = _ref.expireDelay,
      maxEntries = _ref.maxEntries;
  var entries = [];

  if (!cleanupHistoriesInterval) {
    cleanupHistoriesInterval = setInterval(function () {
      return cleanupHistories();
    }, CLEAR_OLD_VALUES_INTERVAL);
  }

  var clearExpiredValues = function clearExpiredValues() {
    var oldTimeThreshold = relativeNow() - expireDelay;

    while (entries.length > 0 && entries[entries.length - 1].endTime < oldTimeThreshold) {
      entries.pop();
    }
  };

  cleanupTasks.add(clearExpiredValues);
  /**
   * Add a value to the history associated with a start time. Returns a reference to this newly
   * added entry that can be removed or closed.
   */

  function add(value, startTime) {
    var entry = {
      value: value,
      startTime: startTime,
      endTime: END_OF_TIMES,
      remove: function remove() {
        removeItem(entries, entry);
      },
      close: function close(endTime) {
        entry.endTime = endTime;
      }
    };

    if (maxEntries && entries.length >= maxEntries) {
      entries.pop();
    }

    entries.unshift(entry);
    return entry;
  }
  /**
   * Return the latest value that was active during `startTime`, or the currently active value
   * if no `startTime` is provided. This method assumes that entries are not overlapping.
   *
   * If `option.returnInactive` is true, returns the value at `startTime` (active or not).
   */


  function find() {
    var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : END_OF_TIMES;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      returnInactive: false
    };

    var _iterator = _createForOfIteratorHelper(entries),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var entry = _step.value;

        if (entry.startTime <= startTime) {
          if (options.returnInactive || startTime <= entry.endTime) {
            return entry.value;
          }

          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  /**
   * Helper function to close the currently active value, if any. This method assumes that entries
   * are not overlapping.
   */


  function closeActive(endTime) {
    var latestEntry = entries[0];

    if (latestEntry && latestEntry.endTime === END_OF_TIMES) {
      latestEntry.close(endTime);
    }
  }
  /**
   * Return all values with an active period overlapping with the duration,
   * or all values that were active during `startTime` if no duration is provided,
   * or all currently active values if no `startTime` is provided.
   */


  function findAll() {
    var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : END_OF_TIMES;
    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var endTime = addDuration(startTime, duration);
    return entries.filter(function (entry) {
      return entry.startTime <= endTime && startTime <= entry.endTime;
    }).map(function (entry) {
      return entry.value;
    });
  }
  /**
   * Remove all entries from this collection.
   */


  function reset() {
    entries = [];
  }
  /**
   * Stop internal garbage collection of past entries.
   */


  function stop() {
    cleanupTasks["delete"](clearExpiredValues);

    if (cleanupTasks.size === 0 && cleanupHistoriesInterval) {
      clearInterval(cleanupHistoriesInterval);
      cleanupHistoriesInterval = null;
    }
  }

  return {
    add: add,
    find: find,
    closeActive: closeActive,
    findAll: findAll,
    reset: reset,
    stop: stop
  };
}